export default __webpack_public_path__ + "static/media/checkIconBlue.a47aca2d.svg";